import { Button } from 'blaze-ui/Button'
import Styles from './StrategiesSelection.module.scss'
import { MultiStepStepLayout } from 'components/MultiStepFlow/MultiStepStepLayout/MultiStepStepLayout'
import { StickyFooterProvider } from 'providers/StickyFooterProvider/StickyFooterProvider'
import { FooterButtons, StickyFooter } from 'components/FirstTimeExperienceModal/components/Footer/Footer'
import { CheckboxGroup } from 'components/CheckboxGroup/CheckboxGroup'
import { useState } from 'react'
import { strategiesDefaultData, Strategy, BusinessType, Goal } from './utils'
import { Strategy as StrategyComponent } from './Strategy'

export interface StrategiesSelectionProps {
  onNext: (brandPlanStrategies: Strategy[]) => void
  onBack: () => void
  initialSelectedStrategies?: Strategy[]
  selectedBusinessType?: BusinessType // TODO: Not optional
  goal?: Goal // TODO: Not optional
}

export const StrategiesSelection = ({
  onNext,
  onBack,
  initialSelectedStrategies,
  selectedBusinessType = 'place', // TODO: pass value from context
  goal = 'grow_through_word_of_mouth', // TODO: pass value from context
}: StrategiesSelectionProps) => {
  const [selectedStrategies, setSelectedStrategies] = useState<Strategy[]>(
    initialSelectedStrategies ||
      strategiesDefaultData[selectedBusinessType].strategies.filter((strategy) =>
        strategy.selected_goals.includes(goal),
      ),
  )

  const strategies = strategiesDefaultData[selectedBusinessType].strategies

  return (
    <MultiStepStepLayout
      title="Based on those goals, here's the specific strategies to create compelling content that will boost growth "
      scrollContainerClassName={Styles.scrollContainer}
    >
      <StickyFooterProvider
        footer={
          <StickyFooter>
            <FooterButtons>
              <Button variant="tertiary" size="lg" onPress={onBack}>
                Back
              </Button>
              <Button size="lg" onPress={() => onNext(selectedStrategies)}>
                Continue
              </Button>
            </FooterButtons>
          </StickyFooter>
        }
      >
        <CheckboxGroup
          value={selectedStrategies.map((strategy) => strategy.id)}
          className={Styles.strategiesContainer}
          aria-label="Strategies"
          onChange={(value) => setSelectedStrategies(strategies.filter((strategy) => value.includes(strategy.id)))}
        >
          {strategies.map((strategy) => (
            <StrategyComponent
              key={strategy.id}
              strategy={strategy}
              onSelect={(strategyId) =>
                setSelectedStrategies(selectedStrategies.filter((strategy) => strategy.id !== strategyId))
              }
            />
          ))}
        </CheckboxGroup>
      </StickyFooterProvider>
    </MultiStepStepLayout>
  )
}
